import React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import toast, { Toaster } from "react-hot-toast";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import PreferencesNav from "./PreferencesNav";
import AddIcon from "@mui/icons-material/Add";

import { getSalePersonDetailKeyValuePair,   addSalePerson, editSalePerson } from "../../services/index";

const SalesPersonList = () => {
  const [salesPersonInfo, setSalesPersonInfo] = useState({});
  const [filteredData, setFilteredData] = useState([]);

  const [show, setShow] = useState(false);
  const handleClose = () => {
    setSalesPersonInfo({});
    setShow(false);
  };

  useEffect(() => {
    getSalesPersonList();
  }, []);

  const getSalesPersonList = () => {
  
    getSalePersonDetailKeyValuePair().then((res) => {
      if (res.errorCode == 0) {
        var d = res.responsePacket;
        setFilteredData(d);
      } else {
        toast(res.message);
        return;
      }
    });
  };

  const columns = [
    {
      name: "Title",
      cell: (row) => row.value,
    },
    {
      name: "Email",
      cell: (row) => row.value2,
    },
  ];

  const handleClicked = (row) => {
    setSalesPersonInfo({
      ...salesPersonInfo,
      recordId: row?.key,
      title: row?.value,
      email: row?.value2,
    });
    setShow(true);
  };

  const handleData = (e) => {
    setSalesPersonInfo({
      ...salesPersonInfo,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = () => {
    if (!salesPersonInfo.email) {
      toast("Please fill email");
      return;
    }
    if (!salesPersonInfo.title) {
      toast("Please fill title");
      return;
    }

    const data = {
      recordId:salesPersonInfo.recordId,
      email: salesPersonInfo.email,
      title: salesPersonInfo.title,
    };
    if (salesPersonInfo.recordId) {
      editSalePerson(salesPersonInfo.recordId, data).then((res) => {
        if (res.errorCode == 0) {
          toast.success(res.message);
          getSalesPersonList();
          handleClose();
        } else {
          toast(res.message);
          return;
        }
      });
    } else {
        addSalePerson(data).then((res) => {
        if (res.errorCode == 0) {
          toast.success(res.message);
          getSalesPersonList();
          handleClose();
        } else {
          toast(res.message);
          return;
        }
      });
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} size="sm">
        <Modal.Header>Salesperson Info</Modal.Header>
        <Modal.Body>
          <table>
            <tr>
              <td>Title:</td>
              <td>
                <input
                  autoComplete="off"
                  className=" form-control"
                  value={salesPersonInfo.title}
                  name="title"
                  onChange={(e) => handleData(e)}
                />
              </td>
            </tr>
            <tr>
              <td>Email:</td>
              <td>
                <input
                  autoComplete="off"
                  className="form-control"
                  name="email"
                  value={salesPersonInfo.email}
                  onChange={(e) => handleData(e)}
                />
              </td>
            </tr>
          </table>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <div className="column list-column d-print-none column-small">
        <PreferencesNav />
      </div> */}
      <div className="column content-column">
        <div className="header clearfix" style={{ borderBottom: "none" }}>
          <span className="float-left" style={{ fontSize: "35px" }}>
            Salesperson List
          </span>
        </div>

        <div style={{ height: 500, width: "100%" }}>
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            onRowClicked={(data) => {
              handleClicked(data);
            }}
            fixedHeader
            subHeader
            subHeaderComponent={
              <>
                <button
                  id="ember5839"
                  className="tooltip-container ember-view btn btn-primary d-flex align-items-center"
                  type="button"
                  onClick={() => setShow(true)}
                >
                  <AddIcon />
                  New
                </button>
              </>
            }
          />
        </div>
      </div>
      <Toaster />
    </>
  );
};

export default SalesPersonList;
